<template>
    <div>
      <h1>Zlecenie:{{danezlecenia.nazwa}}</h1>
<h1  v-if="danezlecenia.czy_zrealizowane == 1">To zlecenie zostało już zrealizowane !!!!</h1>
      <h2>1.Data rozpoczęcia</h2>
       <p v-if="danezlecenia.czy_zrealizowane == 1">  {{danezlecenia.data_rozpoczecia}}</p>
         <v-date-picker  v-if="danezlecenia.czy_zrealizowane == 0" color="indigo" v-model="picker" :landscape="landscape" :reactive="reactive"></v-date-picker>
           <v-time-picker  v-if="danezlecenia.czy_zrealizowane == 0" color="indigo" v-model="godzrozp" :landscape="landscape"
              :allowed-hours="allowedHours"
      :allowed-minutes="allowedMinutes"
            format="24hr"></v-time-picker>
         <h2>2.Data zakończenia</h2>
       <p v-if="danezlecenia.czy_zrealizowane == 1"> {{danezlecenia.data_zakonczenia}}</p>
         <v-date-picker  v-if="danezlecenia.czy_zrealizowane == 0"  color="indigo" v-model="picker2" :landscape="landscape" :reactive="reactive"></v-date-picker>
           <v-time-picker   v-if="danezlecenia.czy_zrealizowane == 0"  color="indigo" 
              :allowed-hours="allowedHours"
      :allowed-minutes="allowedMinutes"
           v-model="godzzak" :landscape="landscape" format="24hr"></v-time-picker>
        
<h2>3. Dodatkowe dane</h2>

<p  v-if="danezlecenia.czy_zrealizowane == 1" ><b>Kilometry:</b> {{danezlecenia.kilometry}}</p>
 <v-text-field  v-if="danezlecenia.czy_zrealizowane == 0" 
          name="input-2"
          label="Ilość kilometrów"
          mask="####"
          class="input-group--focused"
          v-model="ilosckilometrow"
        ></v-text-field>
        <p  v-if="danezlecenia.czy_zrealizowane == 1" ><b>Uwagi:</b> {{danezlecenia.opis}}</p>
           <v-text-field   v-if="danezlecenia.czy_zrealizowane == 0" 
          name="uwagi"
          v-model="uwagi"
          label="UWAGI"
          multi-line
        ></v-text-field>
        <hr/>
     <p>Materiały i usługi</p>

<v-data-table :items="items2" :headers="headers"  hide-actions> 

   <template slot="items" slot-scope="props">
      <td>{{ props.item.nazwa }}</td>
       <td>{{ props.item.pivot.ilosc }}</td>
   
        <td></td>
      </template>
</v-data-table>

    <v-select   v-if="danezlecenia.czy_zrealizowane == 0" 
            item-text="'${data.item.nazwa}, ${data.item.jednostka}'"
            item-value="id"
          label="Wybierz material"
          single-line
          v-model="select"
          :items="items"
        >
         <template slot="item" slot-scope="data">
                  {{ data.item.nazwa}}, {{data.item.jednostka}}
                </template>
                 <template slot="selection" slot-scope="data">
                  {{ data.item.nazwa}}, {{data.item.jednostka}}
                </template>
        </v-select>
 <v-text-field  v-if="danezlecenia.czy_zrealizowane == 0" 
          name="ilosc"
          label="ilosc"
         v-model="ilosc"
          class="input-group--focused"
        ></v-text-field>
  
 





<v-btn  v-if="danezlecenia.czy_zrealizowane == 0"  color="indigo" dark @click="dodajMaterial">Dodaj materiał</v-btn>
<hr/>

<v-btn color="indigo" to="/mz" dark>Powrót</v-btn>

 <v-btn  v-if="danezlecenia.czy_zrealizowane == 0"  color="error" dark @click="zrealizujzlecenie">Zamknij zlecenie</v-btn>
  </div>
</template>


<script>
import axios from 'axios';

  export default {
    data () {
      return {
        uwagi:'',
        godzrozp:null,
        godzzak:null,
        data_roapoczecia:'',
        data_zakonczenia:'',
        ilosckilometrow:'',
        users:'',
        ilosc:'',
        jednostka:'',
        picker: null,
        picker2: null,
        landscape: false,
        reactive: false,
         e1: 0,
        select:'',
        jednostki:[
          { text: 'm' },
          { text: 'kg' },
          { text: 'szt' },
          { text: 'litr'}
        ],
        items:[],
        danezlecenia:'',
        items2:'',
         
        headers:[ { text: 'Nazwa', value: 'nazwa' },{ text: 'Ilość' },{ text: 'Akcja' }]
      }
    },
    created(){
       var data_rozpoczecia=this.picker+' '+this.godzrozp
        var data_zakonczenia=this.picker2+' '+this.godzzak
      const token=localStorage.getItem('token')
      if (token==null){
         this.$router.push('/')
      }

      axios.get('/api/mojezlecenia/dane/'+this.$route.params.idzlec+'?token='+token)
      .then(response =>{
          this.danezlecenia = response.data
      })
       .catch(error=>{
          console.log(error);
          
        })


         axios.get('/api/materialywzleceniu/'+this.$route.params.idzlec)
        .then(response => {

          this.items2 = response.data;
            
          
        })
        .catch(error=>{
          console.log(error);
          
        })
         axios.get('/api/materialy?token='+token)
        .then(response => {

          this.items = response.data;
              
          
        })
        .catch(error=>{
          console.log(error);
          
        })
    },
     methods: {
       usunMaterial (){
        axios.post('/api/usunmatzezlecenia/',{idmat:this.select,idzlec:this.$route.params.idzlec})
        .then(response => {

          this.usuniete = response.data;
            
          
        })
        .catch(error=>{
          console.log(error);
          
        })

       },
      dodajMaterial (){

     axios.post('/api/materialy',{idmat:this.select,ilosc:this.ilosc,jednostka:this.jednostka.text,
     idzlec:this.$route.params.idzlec})
     .then(response => {

         console.log(response);
                axios.get('/api/materialywzleceniu/'+this.$route.params.idzlec)
        .then(response => {

          this.items2 = response.data;
             this.$toasted.success('Materiał został dodany', {duration:2000, position: "bottom-center", theme: "primary" ,fullWidth:true} )
          
        })
        .catch(error=>{
          console.log(error);
          
        })
          
        })
     .catch(error=>{
        console.log(error);
     })
     
   
        
      },
      pokazmaterialy() {
                   axios.get('/api/materialywzleceniu/'+this.$route.params.idzlec)
        .then(response => {

          this.items2 = response.data;
            
          
        })
        .catch(error=>{
          console.log(error);
          
        })
      },
      zrealizujzlecenie (){
         var data_rozpoczecia=this.picker+' '+this.godzrozp
        var data_zakonczenia=this.picker2+' '+this.godzzak
      // alert(data_rozpoczecia)
        axios.post('/api/zrealizujzlecenie/'+this.$route.params.idzlec,{
          data_rozpoczecia:data_rozpoczecia,data_zakonczenia:data_zakonczenia,
          kilometry:this.ilosckilometrow,uwagi:this.uwagi
        })
     .then(response => {
console.log(this.data_rozpoczecia);
console.log(this.data_zakoncenia);
 this.$toasted.success('Pamiętaj o wypisaniu protokułu', {duration:2000, position: "bottom-center", theme: "primary" ,fullWidth:true} )
this.$router.push('/mz')
     })
      .catch(error=>{
          console.log(error);
          
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ZrealizujZlecenia.vue